import { render } from "./ButtonInput.vue?vue&type=template&id=5a1d4c21"
import script from "./ButtonInput.vue?vue&type=script&lang=js"
export * from "./ButtonInput.vue?vue&type=script&lang=js"

import "./ButtonInput.vue?vue&type=style&index=0&id=5a1d4c21&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__